import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteBillPaymentRequestForm.NetSuiteBillPaymentBillsSection.AddBillsPopup.EmptyBillsSection',
    {
        emptyBillsText: 'No matching bills found',
    }
);
